import { useTranslation } from 'react-i18next'

import SuitCaseIcon from 'shared/images/ticket_buy.png'
import { Button } from 'shared/ui/button'

import styles from './styles.module.scss'

export enum BUY_TICKET {
  FOR_MY_SELF = 'for_my_self',
  FOR_OTHER = 'for_other',
}

interface Props {
  onContinue: (type: BUY_TICKET) => void
}

const PopUp = ({ onContinue }: Props) => {
  const { t } = useTranslation()

  const btnStyle = {
    borderRadius: '16px',
    fontWeight: 600,
    fontSize: 17,
  }

  return (
    <div className={styles.container}>
      <img
        src={SuitCaseIcon}
        alt=""
        className={styles.icon}
      />

      <p className={styles.title}>{t('clarify')}</p>
      <p className={styles.titleDesc}>{t('clarify_desc')}</p>

      <div className={styles.buttons}>
        <div className={styles.button}>
          <Button
            style={btnStyle}
            onClick={() => onContinue(BUY_TICKET.FOR_MY_SELF)}
          >
            {t('my_self')}
          </Button>
        </div>
        <div className={styles.button}>
          <Button
            style={btnStyle}
            variant="transparentBlue"
            onClick={() => onContinue(BUY_TICKET.FOR_OTHER)}
          >
            {t('for_other')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default PopUp
